/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  Shared  */
import { FontSizes } from 'application/Shared/Constants';
import { debug } from 'application/Shared/Utils';

/*  React  */
import React from 'react';

/*  NPM  */
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Notify {
    constructor() {
        this.toast = toast;
    }

    info(msg, options = {}) {
        const seconds = options.seconds || 5;

        this.toast.info(msg, {
            autoClose: parseInt(seconds, 10) * 1000,
            icon: <Icon src="KnowledgeFilled" size={FontSizes[3]} />,
            position: options?.position || 'bottom-right',
            theme: 'colored'
        });
    }

    success(msg, options = {}) {
        const seconds = options.seconds || 5;

        this.toast.success(msg, {
            autoClose: parseInt(seconds, 10) * 1000,
            icon: <Icon src="CheckCircle" size={FontSizes[3]} />,
            position: options?.position || 'bottom-right',
            theme: 'colored'
        });
    }

    warning(msg, options = {}) {
        const seconds = options.seconds || 5;

        this.toast.warning(msg, {
            autoClose: parseInt(seconds, 10) * 1000,
            icon: <Icon src="WarningTriangleFilled" size={FontSizes[3]} />,
            position: options?.position || 'bottom-right',
            theme: 'colored'
        });
    }

    error(msg, options = {}) {
        const seconds = options.seconds || 5;

        this.toast.error(msg, {
            autoClose: parseInt(seconds, 10) * 1000,
            icon: <Icon src="Warning" size={FontSizes[3]} />,
            position: options?.position || 'bottom-right',
            theme: 'colored'
        });
        debug.w(msg);
    }

    /* aliases */
    i(msg, options = {}) {
        this.info(msg, options);
    }

    s(msg, options = {}) {
        this.success(msg, options);
    }

    w(msg, options = {}) {
        this.warning(msg, options);
    }

    e(msg, options = {}) {
        this.error(msg, options);
    }
}

export default Notify;
